var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showPndingAjaxLoad || _vm.loading)?_c('div',{staticClass:"p-6 loading-table"},[_c('spinner-color')],1):_c('div',[_c('data-table-order',{attrs:{"data":this.$store.state.dataList.orders,"header":_vm.header,"body":_vm.body,"titlePage":_vm.titlePage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }